/**
 * Reports Module Permission Hooks — Session 1 Foundation
 *
 * Provides 4 permission checks backed by the consolidated permissions RPC:
 *   - useReportsAccess()  → REPORTS_ACCESS  (gate tab visibility)
 *   - useReportsView()    → REPORTS_VIEW    (read reports list)
 *   - useReportsCreate()  → REPORTS_CREATE  (generate new report)
 *   - useReportsAdmin()   → REPORTS_ADMIN   (manage templates/config)
 *
 * Admin users get all 4 = true automatically (RPC short-circuit).
 * Non-admin users default to false until granted via Permission admin UI.
 * No role grants are seeded by this module.
 */
import { useConsolidatedPermissions } from './useConsolidatedPermissions';

interface ReportsPermissionResult {
  data: boolean;
  isLoading: boolean;
}

export const useReportsAccess = (): ReportsPermissionResult => {
  const { data, isLoading } = useConsolidatedPermissions();
  return { data: data?.REPORTS_ACCESS === true, isLoading };
};

export const useReportsView = (): ReportsPermissionResult => {
  const { data, isLoading } = useConsolidatedPermissions();
  return { data: data?.REPORTS_VIEW === true, isLoading };
};

export const useReportsCreate = (): ReportsPermissionResult => {
  const { data, isLoading } = useConsolidatedPermissions();
  return { data: data?.REPORTS_CREATE === true, isLoading };
};

export const useReportsAdmin = (): ReportsPermissionResult => {
  const { data, isLoading } = useConsolidatedPermissions();
  return { data: data?.REPORTS_ADMIN === true, isLoading };
};
